import { PencilLine } from "lucide-react";
import { Button } from "../../../../components/button";
import { NoDataPlaceholder } from "../../../../components/common";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../components/table";
import type { OpportunityHierarchyItem } from "../../types";
import { formatDate } from "../campaign.utils";

interface Props {
  campaignId: string;
  opportunities: OpportunityHierarchyItem[];
  onOpenOpportunityDetail: (campaignId: string, programId: string, opportunityId: string) => void;
}

export function OpportunityHierarchyTable({
  campaignId,
  opportunities,
  onOpenOpportunityDetail,
}: Props) {
  if (!opportunities.length)
    return (
      <NoDataPlaceholder
        title="No opportunities found."
        description="This program does not have any event or survey opportunities yet."
      />
    );
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Opportunity</TableHead>
          <TableHead>Type</TableHead>
          <TableHead>Neighborhood</TableHead>
          <TableHead>Timeline</TableHead>
          <TableHead className="text-right">Action</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {opportunities.map((opportunity) => (
          <TableRow key={opportunity.id}>
            <TableCell>
              <div className="font-medium">{opportunity.name}</div>
              <div className="text-xs text-[#6A7282]">
                {opportunity.description || "No description"}
              </div>
            </TableCell>
            <TableCell>{opportunity.type || "Event"}</TableCell>
            <TableCell>{opportunity.neighborhoodName ?? "No neighborhood assigned"}</TableCell>
            <TableCell>
              {opportunity.startDate && opportunity.endDate
                ? `${formatDate(opportunity.startDate)} - ${formatDate(opportunity.endDate)}`
                : "No timeline"}
            </TableCell>
            <TableCell className="text-right">
              <Button
                type="button"
                variant="outline"
                size="sm"
                aria-label={`Edit ${opportunity.name}`}
                onClick={() =>
                  onOpenOpportunityDetail(campaignId, opportunity.programId, opportunity.id)
                }
              >
                <PencilLine className="h-4 w-4" />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
